'use strict';

const NpawObject = require('../object');
const DeprecatedOptions = require('./optionModules/deprecatedOptions');
const { default: Log } = require('../../common/log');
const TransportFormat = require('../constants/transportFormat');
const StreamingProtocol = require('../constants/streamingProtocols');
const RequestMethod = require('../constants/requestMethod');
const applyCoreOptions = require('./optionModules/coreOptions');
const applyUserOptions = require('./optionModules/userOptions');
const applyParseOptions = require('./optionModules/parseOptions');
const applyNetworkOptions = require('./optionModules/networkOptions');
const applyDeviceOptions = require('./optionModules/deviceOptions');
const applyContentOptions = require('./optionModules/contentOptions');
const applyAdOptions = require('./optionModules/adOptions');
const applyAppOptions = require('./optionModules/appOptions');
const applyBackgroundOptions = require('./optionModules/backgroundOptions');
const applySmartswitchOptions = require('./optionModules/smartswitchOptions');
const { AnalyticsTag } = require('../../common/Constants');

var Options = NpawObject.extend(
  /** @lends npaw.Options.prototype */
  {
    /**
     * This Class store npaw configuration settings.
     * Any value specified in this class, if set, will override the info the plugin is able to get
     * on its own.
     *
     * @constructs Options
     * @param {Object|Options} [options] A literal containing values.
     * @extends npaw.NpawObject
     * @memberof npaw
     */
    constructor: function (options) {
      applyCoreOptions(this, { RequestMethod });

      applyUserOptions(this);
      applyParseOptions(this);
      applyNetworkOptions(this);
      applyDeviceOptions(this);
      applyContentOptions(this);
      applyAdOptions(this);
      applyAppOptions(this);
      applyBackgroundOptions(this);
      applySmartswitchOptions(this);

      this.setOptions(options);
    },

    /**
     * Recursively sets the properties present in the params object.
     * ie: this.username = params.username.
     *
     * @param {Object} options A literal or another Data containing values.
     * @param {Object} [base=this] Start point for recursion.
     * @param isUpdate
     */
    setOptions: function (options, base, isUpdate = false) {
      let isInBase = false;
      let deprecatedOptions;
      if (base === undefined) {
        base = this;
        isInBase = true;
        deprecatedOptions = new DeprecatedOptions();
      }
      if (typeof options !== 'undefined') {
        for (var key in options) {
          let deprecated = false;
          let newKey;
          if (isInBase) {
            if (!this.hasOwnProperty(key)) {
              // eslint-disable-line no-prototype-builtins
              if (deprecatedOptions.exists(key)) {
                newKey = deprecatedOptions.getNewName(key);
                deprecated = true;
              } else if (typeof options[key] !== 'function') {
                Log.warn(AnalyticsTag, 'The option "' + key + '" does not exist, so it cannot be set');
              }
            }
          }
          if (
            isUpdate ||
            (typeof base[key] === 'object' &&
              base[key] !== undefined &&
              !Array.isArray(base[key]) &&
              key === 'parse.cdnNode.list')
          ) {
            this.setOptions(options[key], base[key]);
          } else {
            if (deprecated) {
              base[newKey] = options[key];
            } else {
              base[key] = options[key];
            }
          }
        }
      }
    },

    /**
     * Sets all the values given in an array as extraparams. Limit is 20
     * @param {array<string>} paramsArray array of extraparam strings
     */
    setExtraParams: function (paramsArray) {
      const maxLength = 20;
      if (typeof paramsArray !== 'object' || !paramsArray.length) return;
      if (paramsArray.length >= maxLength) paramsArray = paramsArray.slice(0, maxLength);
      while (paramsArray.length < maxLength) {
        paramsArray.push(undefined);
      }
      paramsArray.forEach((param, index) => {
        this['content.customDimension.' + (index + 1).toString()] = param;
      });
    },

    /**
     * @alias npaw.options.prototype.setExtraParams.
     */
    setCustomDimensions: function () {
      Options.prototype.setExtraParams.apply(this, arguments);
    },

    /**
     * Sets all the values given in an array as extraparams. Limit is 10
     * @param {array<string>} paramsArray array of extraparam strings
     */
    setAdExtraParams: function (paramsArray) {
      const maxLength = 10;
      if (typeof paramsArray !== 'object' || !paramsArray.length) return;
      if (paramsArray.length >= maxLength) paramsArray = paramsArray.slice(0, maxLength);
      while (paramsArray.length < maxLength) {
        paramsArray.push(undefined);
      }
      paramsArray.forEach((param, index) => {
        this['ad.customDimension.' + (index + 1).toString()] = param;
      });
    },

    /**
     * @alias npaw.options.prototype.setAdExtraParams.
     */
    setAdCustomDimensions: function () {
      Options.prototype.setAdExtraParams.apply(this, arguments);
    },

    setEnableLegacyBufferBehaviour: function () {
      Options.prototype.setEnableLegacyBufferBehaviour.apply(this, arguments);
    }
  },
  {
    // Constants
    StreamingProtocol: StreamingProtocol,
    TransportFormat: TransportFormat,
    RequestMethod: RequestMethod
  }
);

module.exports = Options;
module.exports.default = Options;

